import { render, staticRenderFns } from "./platformsColumn.vue?vue&type=template&id=063f4f72&scoped=true"
import script from "./platformsColumn.vue?vue&type=script&lang=js"
export * from "./platformsColumn.vue?vue&type=script&lang=js"
import style0 from "./platformsColumn.vue?vue&type=style&index=0&id=063f4f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f4f72",
  null
  
)

export default component.exports